import { Component, OnInit, AfterContentInit, OnDestroy, Output, Input, EventEmitter, NgZone, ViewChild } from '@angular/core';
import { LocationsFacadeService } from '@services/locations/locations-facade.service';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

import { LocationModel } from '@models/index';
import { phoneNumberMask, zipCodeMask } from '../../../core/utilities/data-utils'
import { MIN_ZIP_ZODE_LENGTH } from '../../../core/utilities/const-utils'
// import { MapsAPILoader } from '@agm/core';
import { } from '@angular/google-maps'
import { SearchCountryField, CountryISO } from '@capgo/ngx-intl-tel-input';
import { Subscription, never } from 'rxjs';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
// declare var google: any;

@Component({
  selector: 'app-locations-form',
  templateUrl: './locations-form.component.html',
  styleUrls: ['./locations-form.component.sass']
})
export class LocationsFormComponent implements OnInit, AfterContentInit {

  @Output() createLocation = new EventEmitter<LocationModel>();
  @Output() editLocation = new EventEmitter<LocationModel>();
  @Output() cancel = new EventEmitter();
  @Input() location: LocationModel;
  @Input() create: boolean;
  @Input() businessCreation: boolean
  @ViewChild("placesRef") placesRef: GooglePlaceDirective;
  @Input() showCancelButton: boolean = true

  locationForm: FormGroup;
  phoneNumberMask = phoneNumberMask;
  zipCodeMask = zipCodeMask;
  mapLocation = new google.maps.LatLng(0, 0);
  markerOptions = {
    draggable: true
  }
  mssgMap: string = '';
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  selectedCountry = 'us';
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.Canada, CountryISO.Australia, CountryISO.UnitedKingdom];
  existShortName$ = this.locationsFacadeService.getExistShortName$();
  existShortName: boolean
  _subs: Subscription = never().subscribe();
  isEnableOpenaiIntegration: boolean;
  isMultiCampaignEnabled: boolean;
  isSentimentCheckEnabled: boolean;
  isZapierEnabled: boolean;

  constructor(
    private fb: FormBuilder,
    private locationsFacadeService: LocationsFacadeService,
    private translate: TranslateService,
    private ngZone: NgZone,
    // private Coder: google.maps.Geocoder
    // private mapsAPILoader: MapsAPILoader
    // private mapLoader: GoogleMap
  ) {
  }

  ngOnInit() {
    this.existShortName = false
    let geoCoder = new google.maps.Geocoder();
    geoCoder.geocode({ address: this.location.address }, (results, status) => {
      if (status === 'OK') {
        this.mapLocation = results[0].geometry.location
      }
    })
    // this.mapsAPILoader.load().then(() => {
    //   let geocoder = new google.maps.Geocoder();
    //   geocoder.geocode({ address: this.location.address }, (results, status: any) => {
    //     if (status === 'OK') {
    //       this.mapLocation = {
    //         lat: results[0].geometry.location.lat(),
    //         lng: results[0].geometry.location.lng()
    //       }
    //     }
    //   });
    // });
    // this.mapLoader.googleMap()
  }

  ngAfterContentInit() {
    this.location = Object.assign({}, this.location);
    this.isEnableOpenaiIntegration = !!this.location.isEnableOpenaiIntegration;
    this.isMultiCampaignEnabled = !!this.location.isMultiCampaignEnabled;
    this.isSentimentCheckEnabled = !!this.location.isSentimentCheckEnabled;
    this.isZapierEnabled = !!this.location.isZapierEnabled;

    this.locationForm = this.fb.group({
      name: [this.location.name, [Validators.required, this.ValidateName]],
      address: [this.location.address ? this.location.address : '', [Validators.required, this.ValidateAddress]],
      phoneNumber: [this.location.phoneNumber, Validators.required],
      zipCode: [this.location.zipCode, [Validators.required, this.ValidateZip]],
      shortName: [this.location.shortName, [this.ValidateShortName]],
      countryCode: [this.location.countryCode],
      shortNameExist: [false, [this.shrtExist]],
      isEnableOpenaiIntegration: [this.location.isEnableOpenaiIntegration ? this.location.isEnableOpenaiIntegration : false],
      openAIReplyLimitRequest: [this.location.openAIReplyLimitRequest ? this.location.openAIReplyLimitRequest : 25],
      isMultiCampaignEnabled: [this.location.isMultiCampaignEnabled ? this.location.isMultiCampaignEnabled : false],
      isSentimentCheckEnabled: [this.location.isSentimentCheckEnabled ? this.location.isSentimentCheckEnabled : false],
      isZapierEnabled: [this.location.isZapierEnabled ? this.location.isZapierEnabled : false],
    });

    this.selectedCountry = this.location.countryCode ? this.location.countryCode.toLowerCase() : 'us';

    this._subs.add(
      this.existShortName$.subscribe(exist => {
        if (this.locationForm.get('shortName').value !== this.location.shortName) {
          this.existShortName = exist;
          this.locationForm.controls.shortNameExist.setValue(exist);
        }
      })
    );
  }

  addGooglePlaceId(event: any) {
    console.log(event);
    // TODO: add a comment: why is this in an ngZone?
    this.ngZone.run(() => this.mapLocation = event.geometry.location)

    const countryCode = event.address_components.filter(item => item.types.includes('country')).length
      ? event.address_components.filter(item => item.types.includes('country'))[0].short_name
      : '';

    this.locationForm.patchValue({
      phoneNumber: event.formatted_phone_number ? event.formatted_phone_number.replace(/[^0-9]/g, '') : '',
      address: event.formatted_address,
      zipCode: event.address_components.filter(item => item.types.includes('postal_code')).length
        ? event.address_components.filter(item => item.types.includes('postal_code'))[0].long_name
        : ''
    });

    this.selectedCountry = countryCode != '' ? countryCode.toLowerCase() : this.selectedCountry
  }

  enterShortName(args) {
    const shortName = args.srcElement.value.toLowerCase().replace(/\s/g, '')
    this.locationForm.controls.shortName.setValue(shortName)
    this.locationsFacadeService.validateShortName(shortName)
  }

  validateShort(args) {
    const shortName = args.srcElement.value.toLowerCase().replace(/\s/g, '')
    this.locationsFacadeService.validateShortName(shortName)
  }

  setMarker(event) {
    let geocoder = new google.maps.Geocoder();

    geocoder.geocode({ location: event.latLng }, (results, status: google.maps.GeocoderStatus) => {
      const countryCode = results[0] ? results[0].address_components.filter((item => item.types.includes(('country')))).length
        ? results[0].address_components.filter((item => item.types.includes(('country'))))[0].short_name
        : ''
        : ''
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          this.addGooglePlaceId(results[0])
          this.mapLocation = results[0].geometry.location
        }
      } else {
        this.locationForm.patchValue({
          address: '',
          zipCode: '',
          phoneNumber: ''
        })
        this.mssgMap = status === google.maps.GeocoderStatus.ZERO_RESULTS
          ? 'This is not a valid place'
          : ''
        setTimeout(() => { this.ngZone.run(() => this.mssgMap = '') }, 2000);
      }
      this.selectedCountry = countryCode != '' ? countryCode.toLowerCase() : this.selectedCountry
    });
  }

  onSubmit() {
    const intlPhoneObj = this.locationForm.value.phoneNumber

    this.locationForm.patchValue({
      phoneNumber: intlPhoneObj ? intlPhoneObj.internationalNumber : '',
      countryCode: intlPhoneObj ? intlPhoneObj.countryCode : 'US',
    })

    const location = {
      ...this.location,
      ...this.locationForm.value,
      countryPrefix: intlPhoneObj.dialCode
    };

    if (!this.create) {
      this.editLocation.emit(location);
    } else {
      this.createLocation.emit(location);
    }
  }

  ValidateName(control: AbstractControl) {
    if (control.value && control.value.trim().length) {
      return null;
    }

    return { invalid: true };
  }

  ValidateShortName(control: AbstractControl) {
    if ((control.value && !control.value.includes(' ')
      && !control.value.match(/[^a-zA-Z0-9\/\-\_]/)
      && (control.value.split('/')).length <= 2
      && control.value.indexOf('/') != 0
      && control.value.indexOf('/') != control.value.length - 1
    ) || control.value.length == 0) {
      return null;
    }

    return { invalid: true };
  }

  shrtExist(control: AbstractControl) {
    if (!control.value) {
      return null;
    }

    return { invalid: true };
  }

  ValidateAddress(control: AbstractControl) {
    if (control.value && control.value.trim().length) {
      return null;
    }

    return { invalid: true };
  }

  ValidateZip(control: AbstractControl) {
    if (control.value && control.value.length >= MIN_ZIP_ZODE_LENGTH && !control.value.match(/[^a-zA-Z0-9\s-]/)) {
      return null;
    }

    return { invalid: true };
  }

  enableOpenaiIntegration(state: boolean) {
    console.log("enableOpenaiIntegration", state);
    this.isEnableOpenaiIntegration = state;
    this.locationForm.patchValue({
      isEnableOpenaiIntegration: state
    });
  }

  enableMulticampaign(state: boolean) {
    console.log("enableMulticampaign", state);
    this.isMultiCampaignEnabled = state;
    this.locationForm.patchValue({
      isMultiCampaignEnabled: state
    });
  }

  multicampaignChanged(event: any) {
    this.locationForm.patchValue({
      isMultiCampaignEnabled: event
    })
  }
  enableSentimentCheck(state: boolean) {
    this.isSentimentCheckEnabled = state;
    this.locationForm.patchValue({
      isSentimentCheckEnabled: state
    });
  }
  enableZapierCheck(state: boolean) {
    this.isZapierEnabled = state;
    this.locationForm.patchValue({
      isZapierEnabled: state
    });
  }

  ngOnDestroy(): void {
    if (this._subs) this._subs.unsubscribe()
  }
}
